"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query userProfiles($query: UserProfileQueryInput) {
    userProfiles(query: $query) {
      _id
      userId
      imageUrl
      user {
        _id
        email
        firstName
        lastName
        phoneNumber
      }
      stripeCustomerId
      stripeCustomer {
        paymentMethods {
          paymentMethodId
          brand
          last4
          expMonth
          expYear
          funding
          country
          type
        }
      }
      analytics {
        label
        type
        interval
        intervalOptions
        coordinates {
          x
          y
        }
        segments {
          label
          type
          coordinates {
            x
            y
          }
        }
      }
      metrics {
        lifeTimeValue
        lifeTimeTicketsPurchased
        eventIds
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=customerProfile.query.js.map